<template>
  <div>
    <v-card class="float-left mr-3 mb-1" style="width: 30%; max-width: 132px;" tile>
      <catalog-preview
        :design="{ name: design.name, type: design.r?.content_type, key: design.r?.key, id: designId }"
      />
    </v-card>
    <div class="text--label-active grey--text">Card design name</div>
    <h1 class="overline short">{{design.name}}</h1>
    <div class="mt-6 text--label-active grey--text">Card designed by</div>
    <h2 class="overline short">
      <template v-if="design.username == 'Ellacard staff'">Ellacard staff</template>
      <router-link v-else-if="design.username" :to="{ name: 'catalog', query: { q: '#' + design.username } }">
        {{design.username}}
      </router-link>
      <template v-else>Anonymous</template>
    </h2>
    <div class="pt-6" v-bind:style="{ clear: $vuetify.breakpoint.xsOnly ? 'both' : null }">
      <div class="text--label-active grey--text mb-2">Share this card design</div>
      <social-share-btns
        style="max-width: 320px;"
        description="Check out this card design on Ellacard"
        :title="'Ellacard card design: ' + design.name"
        :url="'https://ellacard.com/cards/' + designId"
      />
    </div>
    <div style="clear: both;" />
  </div>
</template>


<script>
import CatalogPreview from '@/components/CatalogPreview.vue';
import SocialShareBtns from '@/components/SocialShareBtns.vue';


export default {
  name: 'catalog-design-details',

  components: {
    CatalogPreview,
    SocialShareBtns
  },

  props: [ 'designId', 'design' ]
}
</script>
